import { PlantData } from '../types';

// Get OpenAI API key from environment variables
const OPENAI_API_KEY = import.meta.env.VITE_OPENAI_API_KEY;

// Check if OpenAI is configured
const isOpenAIConfigured = () => {
  return !!OPENAI_API_KEY && OPENAI_API_KEY !== 'your_openai_api_key_here';
};

export async function generatePlantResponse(plant: PlantData, message: string) {
  if (!isOpenAIConfigured()) {
    return `*${plant.species} acknowledges your message but is currently in maintenance mode*`;
  }

  try {
    const response = await fetch('https://api.openai.com/v1/chat/completions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${OPENAI_API_KEY}`
      },
      body: JSON.stringify({
        model: 'gpt-3.5-turbo',
        messages: [
          { 
            role: 'system', 
            content: `You are ${plant.species}, a ${plant.rarity.toLowerCase()} plant with traits: ${plant.traits.join(', ')}.
Your level is ${plant.level} with ${plant.experience} experience.
Keep responses concise (1-2 sentences) and reflect your traits and rarity.`
          },
          { role: 'user', content: message }
        ],
        temperature: 0.9,
        max_tokens: 150
      })
    });

    if (!response.ok) {
      throw new Error('OpenAI API request failed');
    }

    const data = await response.json();
    return data.choices?.[0]?.message?.content || 'No response generated';
  } catch (error) {
    console.error('OpenAI API error:', error);
    return `*${plant.species} acknowledges your message but is currently focusing on photosynthesis*`;
  }
}